import React from 'react';
import { Link } from 'react-router-dom';
import { Utensils, Droplets, Heart, Wrench } from 'lucide-react';
import { buildRoute } from '@/shared/lib/constants';

interface QuickActionsBarProps {
  farmId: string;
}

const actions = [
  {
    id: 'feeding',
    label: 'Feed Records',
    icon: Utensils,
    color: 'bg-emerald-50 text-emerald-600 border-emerald-200/50 hover:bg-emerald-100',
    getRoute: (farmId: string) => buildRoute.feed(farmId),
  },
  {
    id: 'water-test',
    label: 'Water Quality',
    icon: Droplets,
    color: 'bg-blue-50 text-blue-600 border-blue-200/50 hover:bg-blue-100',
    getRoute: (farmId: string) => buildRoute.waterQuality(farmId),
  },
  {
    id: 'health-check',
    label: 'Fish Health',
    icon: Heart,
    color: 'bg-purple-50 text-purple-600 border-purple-200/50 hover:bg-purple-100',
    getRoute: (farmId: string) => buildRoute.fishHealth(farmId),
  },
  {
    id: 'maintenance',
    label: 'Maintenance',
    icon: Wrench,
    color: 'bg-amber-50 text-amber-600 border-amber-200/50 hover:bg-amber-100',
    getRoute: (farmId: string) => buildRoute.maintenance(farmId),
  },
];

export const QuickActionsBar: React.FC<QuickActionsBarProps> = ({ farmId }) => {
  return (
    <div className="flex flex-wrap gap-3">
      {actions.map((action) => {
        const Icon = action.icon;
        return (
          <Link
            key={action.id}
            to={action.getRoute(farmId)}
            className={`flex items-center gap-2 px-4 py-2.5 rounded-lg border transition-colors ${action.color}`}
          >
            <Icon className="h-5 w-5" />
            <span className="font-medium text-sm">{action.label}</span>
          </Link>
        );
      })}
    </div>
  );
};
